import { sendMessage } from '../services/sql-api';
import { ThumbnailWithLocationNameWithStatelems } from '../models/query-response';
import * as Location from '../models/location';

export const fetchThumbnailsWithStatelemsForLocations = async (
  recordingIds: Array<string>,
  locationIds: Array<string>,
  locations: Array<Location.t>,
): Promise<Map<string, ThumbnailWithLocationNameWithStatelems[]>> => {
  const results = await sendMessage('detail', 'list', {
    entities: locationIds,
    entityType: 'location',
    returnEntityType: 'thumbnails-with-statelems',
  });

  let thumbsByRecording = new Map();
  if (results && Array.isArray(results) && results.length > 0) {
    recordingIds.forEach((recordingId) => {
      const thumbnail = results.find(
        (thumb) => thumb.recording_id === recordingId,
      );
      if (thumbnail) {
        thumbsByRecording.set(recordingId, {
          ...thumbnail,
          locationName: Location.getLocationName(
            thumbnail.location_id,
            locations,
          ),
        });
      }
    });
  }

  return thumbsByRecording;
};
